import styled from "styled-components";

export const AuthContainer = styled.section`
  margin: 80px auto 0;
  height: calc(100% - 80px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--white);

  .cnpj-assessor-cadastro {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    align-items: end;
    span {
      color: var(--ant-primary-color);
      font-weight: bolder;
      cursor: pointer;
    }
    .ant-form-item {
      margin-bottom: 1px;
      width: 100%;
    }
  }

  .auth-content {
    min-height: 100%;
    margin: 0 auto;
    max-width: calc(100% - 128px);
    padding: 48px 0;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    h1 {
      color: var(--black);
      margin: 0 0 32px;
    }

    p {
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--black);
      margin: 0 0 32px;
      text-align: center;
    }

    .form-container {
      width: 420px;
      &.register {
        width: 550px;
      }

      form {
        row-gap: 0;
        display: flex;
        flex-direction: column;
      }

      .bottom-acessar {
        display: flex;
        justify-content: center;
      }
    }
  }

  .buttons {
    margin: 0 0 16px;
    display: flex;
    column-gap: 16px;
    align-items: center;
    justify-content: space-between;
    .ant-btn-primary {
      min-width: 200px;
      text-transform: uppercase;
    }
  }

  .btn-underlined {
    padding: 0;
    font-weight: 600;
    text-decoration: none;
    border-bottom: 2px solid var(--veloprime-soft-gold);
  }

  .password-with-eye {
    position: relative;

    button {
      position: absolute;
      right: 8px;
      top: 5px;
    }
  }

  .termos {
    color: var(--dark-2);
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
  }

  .ant-radio-group {
    flex-direction: row;
    margin: 0 0 16px;
    .ant-radio-button-wrapper {
      min-width: 50%;
      font-weight: 300;
      text-align: center;
    }
    .ant-radio-button-wrapper-checked {
      font-weight: 500;
      color: var(--velotax-font-color);
    }
  }

  .footer {
    display: flex;
    column-gap: 16px;
    align-items: center;
    width: 100%;
    padding: 16px 0;
    margin: 24px auto 0;
    color: var(--velotax-font-color);
    border-top: 1px solid var(--light-gray);
  }

  .checkbox {
    margin-top: 8px;
  }

  @media screen and (max-width: 576px) {
    .auth-content {
      border-left: none;
      padding: 64px 24px 0;

      :before {
        display: none;
      }

      .form-container {
        width: 100% !important;
      }
    }

    .buttons {
      button {
        width: 100%;
      }

      button + button {
        display: none;
      }
    }

    .footer {
      margin: 48px auto 0;
    }
  }

  .ant-tabs {
    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0;
    }
    .ant-tabs-nav {
      margin: 0 0 32px;
      .ant-tabs-nav-operations {
        display: none;
      }
      .ant-tabs-nav-wrap {
        .ant-tabs-nav-list {
          width: 100%;
          .ant-tabs-ink-bar {
            background-color: var(--black);
          }
          .ant-tabs-tab {
            width: 50%;
            justify-content: center;
            .ant-tabs-tab-btn {
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
              color: var(--gray-1);
            }
            &.ant-tabs-tab-active {
              .ant-tabs-tab-btn {
                color: var(--black);
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    .auth-content {
      max-width: 100%;
      padding: 48px 24px 64px;
      border-left: none;
    }
  }
`;
